/*
 * File: index.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-07 10:46:57
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import Vue from "vue";

/// register components
const requireComponent = require.context("./../components", true, /\/.*\.vue?$/);

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = `ivc-${fileName
        ?.split("/")
        ?.pop()
        ?.replace(/\.vue$/, "")}`;

    // console.log("file!", fileName, componentName, componentConfig);

    Vue.component(componentName, componentConfig.default || componentConfig);
});

/// register directives (ANY */directives/*.ts under components)
const requireDirective = require.context(
    "./../components",
    true,
    /\/directives\/.*\.ts$/,
);

// 可選：避免重名時你完全不知道誰覆蓋誰
const registered = new Set<string>();

requireDirective.keys().forEach((fileName) => {
    const directiveConfig = requireDirective(fileName);
    const directive = directiveConfig.default || directiveConfig;

    if (!directive) return;

    // v-cell-action-add 這種命名習慣
    const directiveName = fileName?.split("/")?.pop()?.replace(/\.ts$/, "");

    if (!directiveName) return;

    // 可選：重名提示
    if (registered.has(directiveName)) {
        // 你要更嚴格可以直接 throw
        // 這裡先用 warn 讓你知道覆蓋發生了
        // eslint-disable-next-line no-console
        console.warn(
            `[directives] duplicated name "${directiveName}" registered again by: ${fileName}`,
        );
    }

    registered.add(directiveName);

    Vue.directive(directiveName, directive);
});
